"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctIconPosition = void 0;
var Icon_1 = require("./Icon");
exports.correctIconPosition = function (position, weight) {
    if (weight === 'light' && position > Icon_1.MAX_LIGHT_POSITION) {
        return Icon_1.MAX_LIGHT_POSITION;
    }
    if (weight === 'solid' && position > Icon_1.MAX_SOLID_POSITION) {
        return Icon_1.MAX_SOLID_POSITION;
    }
    return position;
};
